import axios from "axios";
import { getCookieValue } from "../helpers/GetCookieValue";
import { deleteCookie } from "../helpers/DeleteCookie";
import { PATHNAMES } from "../constants/pathNames";

export const API_URL = __URL__;

const { loginPath } = PATHNAMES;

const $api = axios.create({
  baseURL: API_URL,
});

$api.interceptors.request.use((config) => {
  const token = getCookieValue("access-token");
  config.headers.Authorization = `Bearer ${token}`;

  if (!config.headers["Content-Type"]) {
    config.headers["Content-Type"] = "application/json";
  }
  if (!config.headers.Accept) {
    config.headers.Accept = "application/json";
  }
  return config;
});

export const SetupInterceptor = (navigate: (path: string) => void) => {
  $api.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (
        error.response?.status === 401 &&
        !window.location.pathname.includes(PATHNAMES.ordersPath)
      ) {
        deleteCookie("access-token");
        deleteCookie("access-token", "/users");
        navigate(loginPath);
      }
      return Promise.reject(error);
    },
  );
};

export default $api;
